import React, { useContext } from 'react';
import {
	AlertContainer,
	Container,
	SectionLogo,
	SkeletonContainer,
} from './Header.styles';
import {
	Paragraph,
	Skeleton,
	StepperNavigation,
	tokens,
} from '@welbe/web-design-system';
import { ReactComponent as Heart } from 'App/assets/img/heart.svg';
import { StepProps } from '../../FormRisk.types';
import { JobProfileContext } from 'Views/JobProfile/JobProfile.context';
import { JobProfileType } from 'Views/JobProfile/JobProfile.enums';
import { FiAlertCircle } from 'react-icons/fi';

type HeaderProps = {
	steps: StepProps[];
	active: number;
	loading: boolean;
	complete: number;
	onNavigate: (step: StepProps) => void;
};

const SkeletonLoading = () => {
	return (
		<SkeletonContainer>
			<Skeleton width="60px" height="60px" borderRadius="50%" />
			<Skeleton width="324px" />
			<Skeleton width="60%" />
			<Skeleton width="700px" />
		</SkeletonContainer>
	);
};

export const Header = ({
	steps,
	active,
	loading,
	complete,
	onNavigate,
}: HeaderProps) => {
	const { jobProfileType } = useContext(JobProfileContext);

	if (loading) {
		return <SkeletonLoading />;
	}

	return (
		<Container>
			<SectionLogo>
				<Heart />
			</SectionLogo>
			<Paragraph
				margin="54px 0 20px 0"
				fontSize="16px"
				fontWeight="600"
				textAlign="center"
				color={tokens.color_primary}
			>
				{jobProfileType === JobProfileType.RISK_PROFILE
					? ' Riesgos asociados a la actividad laboral'
					: 'Riesgos asociados al área de exposición'}
			</Paragraph>
			<StepperNavigation
				active={active}
				complete={complete}
				items={steps}
				itemLabel="name"
				onClick={(item) => onNavigate(steps[item.id])}
			/>
			<Paragraph
				margin={
					jobProfileType === JobProfileType.RISK_PROFILE ? '50px 0' : '20px 0'
				}
				fontSize="18px"
				fontWeight="400"
			>
				Selecciona los <strong>factores de riesgo {steps[active]?.name}</strong>{' '}
				a los que el colaborador de este puesto se expone
			</Paragraph>
			{jobProfileType === JobProfileType.EXPOSITION_AREA && (
				<AlertContainer>
					<FiAlertCircle color={tokens.color_primary} size={25} />
					<Paragraph>
						Los estudios médicos son propuestos en función de la normatividad de
						la Secretaría del Trabajo, por lo que la selección de estos, queda
						sujeta a lo que determinen los responsables de seguridad y salud en
						el trabajo de la empresa.
					</Paragraph>
				</AlertContainer>
			)}
		</Container>
	);
};
